import smoothScrollPolyfill from 'smoothscroll-polyfill'
import { isDOMAccessible } from '@/utils/dom'

export default () => {
  if (isDOMAccessible()) {
    smoothScrollPolyfill.polyfill()
  }
}
